import { copyJson, getExist } from '../utils/function'
import { getConvertType } from './type'
import optionModel from './convert-fields/option'
import questionModel from './convert-fields/question'
import optionTypes from './convert-fields/option-types'
import questionTypes from './convert-fields/question-types'
import answerModel from './convert-fields/answer'
import answerTypes from './convert-fields/answer-types'

export function getAnswerFields (type) {
  let $answerModel = copyJson(answerModel)
  let answer = {}
  answerTypes[type].forEach((field) => {
    answer[field] = $answerModel[field]
  })
  return answer
}

export function convertQuestions (questions) {
  let $questions = []

  questions.forEach((question) => {
    // 深复制一个模型
    let $questionModel = copyJson(questionModel)
    // 当前问题
    let $question = {}
    // 当前选项
    let $options = []
    // 获得问题的类型
    let type = getConvertType(question.type)
    // 获得该类型的问题拥有的字段
    let questionFields = questionTypes[type]
    // 获得该类型的选项拥有的字段
    let optionFields = optionTypes[type]
    if (question.allow_screen_capture === undefined) {
      question.allow_screen_capture = 1
    }

    if (question.allow_media_download === undefined) {
      question.allow_media_download = 1
    }

    // 从 question 模型中取得字段的默认值
    questionFields.forEach((key) => {
      $question[key] = getExist(question[key], $questionModel[key])
      switch (key) {
        case 'id':
          $question[key] = question.stepId
          break
        case 'type':
          $question[key] = type
          break
        case 'text':
          if (question.desc) { $question[key] = getExist(question.desc, $question[key]) }
          break
        case 'textPrefix':
          if (question.descPrefix) { $question[key] = getExist(question.descPrefix, $question[key]) }
          break
        case 'referIds':
          $question[key] = getExist(question.referIds || undefined, $question[key])
          // 兼容旧版单个ID
          if (question.referStepId && !$question[key].includes(question.referStepId)) {
            $question[key].push(question.referStepId)
          }
          break
        case 'images':
          let images = []
          question.images.forEach((src) => {
            images.push({
              type: 'photo',
              src,
            })
          })
          $question[key] = images
          break
        case 'minDuration':
          if (question.evidenceType === 'video' && question.videoDuration > 0) {
            $question[key] = question.videoDuration
          } else if (question.evidenceType === 'record' && question.recordDuration > 0) {
            $question[key] = question.recordDuration
          } else {
            $question[key] = $question[key]
          }
          break
        case 'localFile':
          // 表意问题，取反处理，强制使用爱零工相机===不允许使用本地文件
          if (question.hasOwnProperty('forceCamera')) {
            question.forceCamera = !question.forceCamera
          }
          $question[key] = getExist(question.forceCamera, $question[key])
          break
        case 'jumpTargetId':
          if (question.default_jump) { $question[key] = question.default_jump }
          break
        case 'needEvidence':
          $question[key] = getExist(question.needPhoto, $question[key])
          break
        case 'options':
          $question[key] = question.moptions ||
            question.mtext || question.pictureMultipleOptions || $question[key]
          break
      }
    })

    // 从 option 模型中取得字段的默认值
    if (optionFields.length) {
      $question.options.forEach(option => {
        // 深复制一个模型
        let $optionModel = copyJson(optionModel)
        let $option = {}
        optionFields.forEach((key) => {
          $option[key] = getExist(option[key], $optionModel[key])
          switch (key) {
            case 'id':
              $option[key] = getExist(option.optionId, option.id)
              break
            case 'referIds':
              $option[key] = getExist(option.referIds || undefined, $option[key])
              // 兼容旧版单个ID
              if (option.referStepId && !$option[key].includes(option.referStepId)) {
                $option[key].push(option.referStepId)
              }
              break
            // 图片多选题
            case 'images':
              let images = []
              option.titlePictures.forEach((src) => {
                images.push({
                  type: 'photo',
                  src,
                })
              })
              $option[key] = images
              break
            case 'exampleImages':
              let exampleImages = []
              option.examplePhotos.forEach((src) => {
                exampleImages.push({
                  type: 'photo',
                  src,
                })
              })
              $option[key] = exampleImages
              break
            case 'mutexOptions':
              if (option.exclusiveOption) { $option[key] = option.exclusiveOption }
              break
            case 'nextSelectDelay':
              if (option.mStepDelay) { $option[key] = option.mStepDelay }
              break
            case 'localFile':
              // 表意问题，取反处理，强制使用爱零工相机===不允许使用本地文件
              if (option.hasOwnProperty('forceCamera')) {
                option.forceCamera = !option.forceCamera
              }
              $option[key] = getExist(option.forceCamera, $option[key])
              break
            case 'needEvidence':
              $option[key] = getExist(option.needPhoto, $option[key])
              break
          }
        })

        // 打散逻辑跳转集合到选项中
        if (question['conditional_jump'] && Object.keys(question['conditional_jump']).length) {
          let jumpTargetId = question['conditional_jump'][$option.id]
          if (jumpTargetId) {
            $option.jumpTargetId = jumpTargetId
          }
        }
        $options.push($option)
      })
    }

    // 选项存在则赋值
    if ($options.length) {
      $question.options = $options
    }

    // 完成
    $questions.push($question)
  })

  return $questions
}

/**
 * 根据题目类型，获得选择题的答案
 * @param type
 * @param answer
 * @returns {*[]|Array}
 */
function getAnswerSelectedOptionId (type, answer) {
  switch (type) {
    case 'select':
      if (answer.selectedOptionId) {
        return [answer.selectedOptionId]
      }
      break
    case 'multiselect':
      if (answer.mOptionIds && answer.mOptionIds.length) {
        return answer.mOptionIds
      }
      break
    case 'imageMultiselect':
      if (answer.pictureMultipleOptionIds && answer.pictureMultipleOptionIds.length) {
        return answer.pictureMultipleOptionIds
      }
      break
  }
  return []
}

export function convertAnswers (questions, answers) {
  let $answers = []

  questions.forEach((question, index) => {
    // 深复制一个模型
    let $answerModel = copyJson(answerModel)

    // 获得答案字段模型
    let answerFields = answerTypes[question.type]

    // 获得当前题目的答案
    let answer = answers[index]

    // 转换后的答案
    let $answer = {}

    // 从 answer 模型中取得字段的默认值
    answerFields.forEach((key) => {
      $answer[key] = getExist(answer[key], $answerModel[key])
      switch (key) {
        case 'errorMessage':
          $answer[key] = answer.errormessage
          break
        case 'selectedOptionId':
          $answer[key] = getAnswerSelectedOptionId(question.type, answer)
          break
        case 'text':
          $answer[key] = answer.textAnswer
          break
        case 'texts':
          let texts = []
          question.options.forEach(({id}) => {
            let text = ''
            if (answer.mTextAnswer && answer.mTextAnswer[id] && answer.mTextAnswer[id].textAnswer) {
              text = answer.mTextAnswer[id].textAnswer
            }
            texts.push(text)
          })
          $answer[key] = texts
          break
        case 'evidences':
          let evidences = []
          switch (question.evidenceType) {
            case 'photo':
              answer.photos.forEach((src) => {
                evidences.push({
                  type: 'photo',
                  src,
                })
              })
              break
            case 'video':
              answer.videos.forEach(({thumbUrl, videoUrl}) => {
                evidences.push({
                  type: 'video',
                  src: videoUrl,
                  cover: thumbUrl,
                })
              })
              break
            case 'record':
              answer.records.forEach((val) => {
                evidences.push({
                  type: 'record',
                  src: val,
                })
              })
              break
            case 'qrcode':
              answer.qrcodes.forEach((val) => {
                evidences.push({
                  ...val,
                  type: 'qrcode',
                  src: val.image_url,
                })
              })
              break
          }
          $answer[key] = evidences
          break
      }
    })

    $answers.push($answer)
  })

  return $answers
}

export default {convertQuestions, convertAnswers}



// WEBPACK FOOTER //
// ./src/views/question-editor/format/convert.js